// KEEP CONSISTENT WITH THE CORRESPONDING CSS VARIABLES
class CssConstants {
  static SCREEN_SMALL_MIN = 826;

  // $screen-sm-min. This is the width of nav bar in German, the widest it will ever be
  static SCREEN_MEDIUM_MIN = 1024; // $screen-md-min

  static COLOR_WHITE = '#FFFFFF';

  // $white
  static COLOR_AA_BACKGROUND = '#FBFBF9'; // $aa-grey-background

  static MAX_PROFILE_IMG_SIZE_DESKTOP = 300;

  // $max-profile-img-size-desktop
  static MAX_PROFILE_IMG_SIZE_MOBILE = 225; // $max-profile-img-size-mobile
}

export default CssConstants;
